export default __webpack_public_path__ + "assets/image-component.62cfcbc0.svg";